/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const microsoftAspNetCoreMvcProblemDetailsSchema = z
  .object({
    type: z.string().nullish(),
    title: z.string().nullish(),
    status: z.int().nullish(),
    detail: z.string().nullish(),
    instance: z.string().nullish(),
  })
  .catchall(z.any());
